import Micromodal from 'micromodal'

const TrainingPlanManager = (() => {

  let creationExercisesUser = null

  const manageCreationExercises = () => {
    const buttons = document.querySelectorAll('.js-trainingplanmanager-add-exercises-button')
    const exercises = document.querySelectorAll('.js-trainingplanmanager-add-exercises-exercise')
    if (!buttons || buttons.length < 1 || !exercises || exercises.length < 1) return

    buttons.forEach((b) => {
      b.addEventListener('click', (e) => {
        e.preventDefault()

        creationExercisesUser = b.getAttribute('data-user')
        const input = document.querySelector(`.js-trainingplanmanager-add-exercises-input[data-user="${creationExercisesUser}"]`)
        if (!input) return

        const values = input.value.split(',')
        exercises.forEach((ex) => {
          const exercise = ex.getAttribute('data-exercise')
          if (values.includes(exercise)) {
            ex.innerText = 'Selected'
            ex.classList.remove('c-button--main')
            ex.classList.add('c-button--success')
          } else {
            ex.innerText = 'Select'
            ex.classList.add('c-button--main')
            ex.classList.remove('c-button--success')
          }
        })

        Micromodal.show('modalAddExercises')
      })
    })

    exercises.forEach((ex) => {
      ex.addEventListener('click', (e) => {
        e.preventDefault()

        const exercise = ex.getAttribute('data-exercise')
        const input = document.querySelector(`.js-trainingplanmanager-add-exercises-input[data-user="${creationExercisesUser}"]`)
        if (!input) return

        if (ex.classList.contains('c-button--success')) {
          const valueArray = input.value.split(',')
          const indexArray = valueArray.indexOf(exercise)
          if (indexArray > -1) valueArray.splice(indexArray, 1);
          input.value = valueArray.join(',')
          ex.innerText = 'Select'
          ex.classList.add('c-button--main')
          ex.classList.remove('c-button--success')
        } else {
          input.value = input.value.split(',').concat([exercise]).join(',')
          ex.innerText = 'Selected'
          ex.classList.remove('c-button--main')
          ex.classList.add('c-button--success')
        }
      })
    })
  }

  const init = () => {
    manageCreationExercises()
  }

  return {
    init
  }
})()

export default TrainingPlanManager


// WEBPACK FOOTER //
// app/javascript/scripts/components/TrainingPlanManager.js